import { useCallback, useState } from 'react';
import { Popover } from 'react-tiny-popover';

import { useAnalytics } from '../../../contexts';
import { Device } from '../../../enums';
import { useExportToPdf } from '../../../features/report';
import { DownloadReportButton, DownloadReportPopover } from './compontents';

export const DownloadReport = () => {
  const analytics = useAnalytics();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleOnClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  const { exportPhysiologicalDataToPdf, isLoading } = useExportToPdf();

  const handleGenerate = useCallback(
    (selectedDevices: Device[]) => {
      exportPhysiologicalDataToPdf(selectedDevices);
      analytics.track('Generate report');
    },
    [exportPhysiologicalDataToPdf],
  );

  return (
    <Popover
      align="end"
      reposition={false}
      padding={8}
      isOpen={isPopoverOpen}
      onClickOutside={handleClose}
      positions={['bottom']}
      containerClassName="z-10"
      content={<DownloadReportPopover onClose={handleClose} onDownload={handleGenerate} />}
    >
      <DownloadReportButton loading={isLoading} onClick={handleOnClick} />
    </Popover>
  );
};
